import React, { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NumberFormat from "react-number-format";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { loadDocumentPreview } from "../../../store/actions/documentPreview";

const Option = Select.Option;

const Controls = (props) => {  
  const {handleExitFullscreen, isDragged, isFullscreen, scrollerAreaPreview, 
    setIsFullscreen, zoomIn, zoomOut, zoomLevel, setZoomLevel} = props;
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const previewData = useSelector(state => state.documentPreview?.documents);
  const idAttachment = useSelector(state => state.precog.invoiceDetail?.data?.doc?.id); // "62a51f0f-31a0-4c72-bf0a-0f5d775fbd38"; 
  const totalPages = previewData?.[idAttachment]?.numberOfPages;
  const accountantSelected = main.accountantSelected;
  const accountantIdSelected = main.accountantIdSelected;
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;

  const [currentPage, setCurrentPage] = useState(1);
  const [currentScrollPos, setCurrentScrollPos] = useState(0);
  const [scrollTotalHeight, setScrollTotalHeight] = useState(0);
  // se lo zoom è da tasto non deve zoomare via input
  const [isZoomBtn, setIsZoomBtn] = useState(false);

  const dispatch = useDispatch();

  const changePreviewPage = (page) => {
    setCurrentPage(parseInt(page));
    dispatch(loadDocumentPreview(
      auth, accountantSelected, accountantIdSelected, companySelected, clientIdSelected, idAttachment, page
    ));
  };
  
  const handleScroll = useCallback(() => {
    setCurrentScrollPos(scrollerAreaPreview?.current?.scrollTop);
  }, [scrollerAreaPreview?.current?.scrollTop]);

  useEffect(() => {
    if (!scrollerAreaPreview?.current || !isDragged) return;
    setScrollTotalHeight(scrollerAreaPreview?.current?.scrollHeight);
  }, [isDragged, scrollerAreaPreview ]);

  useEffect(() => {
    if (!scrollerAreaPreview?.current) return;
    scrollerAreaPreview?.current?.addEventListener("scroll", handleScroll);
  }, [handleScroll, scrollerAreaPreview]);
  
  const updateScale = (val) => {    
    if (isZoomBtn){
      setIsZoomBtn(false);
      return undefined;
    }              
    const scale = props.state.scale;
    const targetScale = parseFloat(val) > 0.1 ? (parseFloat(val) <= 2 ? parseFloat(val) : 2) : 0.1;
    const factor = Math.log(targetScale / scale);
    
    if (targetScale > scale) {      
      zoomIn(
        factor, 500, "easeInCubic"
      );
    } else {
      // zoomOut((-factor / 100), 0);
      zoomOut(
        -factor, 500, "easeOut"
      );
    }      
    setZoomLevel((targetScale * 100).toFixed(0));
    return undefined;
  };

  return (
    <div id="previewControls">
      <div id="zoomControl">
        <div data-testid="zoom-minus" tabIndex={0} style={{padding: "0 5px 0 10px", cursor: "pointer"}} 
          onClick={(e) => {            
            e.stopPropagation();            
            const targetScale = props.state.scale - 0.1;
            const factor = Math.log(targetScale / props.state.scale);
            setZoomLevel((Math.abs((props.state.scale - 0.1) * 100)).toFixed(0));  
            setIsZoomBtn(true); 
            zoomOut(
              -factor, 500, "easeOut"
            );               
          }
          }>
          <FontAwesomeIcon icon={["far", "minus"]} style={{color: "#0090d1"}} />
        </div>
        <NumberFormat 
          data-testid={"zoom-number-input"}
          className="percentageVal" allowNegative={false} value={zoomLevel}
          onValueChange={el => {            
            // props.setScale((el.value * 100).toFixed(0));
            updateScale(el.floatValue / 100);
          }}
        />
        <div data-testid="zoom-plus"  tabIndex={0} style={{padding: "0 10px 0 5px", cursor: "pointer"}}
          onClick={(e) => {    
            e.stopPropagation();   
            e.preventDefault();    
            const targetScale = 0.1 + props.state.scale;
            const factor = Math.log(targetScale / props.state.scale);
            setZoomLevel(((0.1 + props.state.scale) * 100).toFixed(0));   
            setIsZoomBtn(true);   
            zoomIn(
              factor, 500, "easeInCubic"
            );                 
          }
          }>
          <FontAwesomeIcon icon={["far", "plus"]} style={{color: "#0090d1"}} />
        </div>
      </div>
      <div style={{width: "100%"}} data-testid="pageSelector">
        <span style={{marginRight: "16px"}}> Pagina </span>
        <Select value={currentPage}           
          onChange={val => {
            console.debug("###### currentPage SELECT : " + val);
            changePreviewPage(val);
          }}
          getPopupContainer={trigger => trigger.parentNode.parentNode}>
          {
            new Array(totalPages).fill(0).map((_, index) => {
              return <Option value={index + 1} key={`singlePage_${index + 1}`}> {index + 1} </Option>;
            })            
          }                    
        </Select>
        <span style={{marginLeft: "8px"}}> di {totalPages} </span>
        <span data-testid="prev-page" onClick={e => {          
          currentPage > 1 && changePreviewPage(currentPage - 1);
        }
        } 
        style={{opacity: `${currentPage === 1 ? 0.3 : 1}`, padding: "0px 8px 0px 16px", 
          cursor: currentPage === 1 ? "default" : "pointer"}}>
          <FontAwesomeIcon icon={["far", "angle-left"]} style={{color: "#0090d1"}} />
        </span>
        <span data-testid="next-page" onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          currentPage < totalPages && changePreviewPage(currentPage + 1);
        } }  
        style={{opacity: `${currentPage === totalPages ? 0.3 : 1}`, padding: "0px 16px 0px 8px", 
          cursor: currentPage === totalPages ? "default" : "pointer"}}>
          <FontAwesomeIcon icon={["far", "angle-right"]} style={{color: "#0090d1"}} />
        </span>
      </div>
      <div style={{width: "100%", marginLeft: "5vw"}}>
        <span onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          if (currentScrollPos <= 0) return;   
          
          const nextPosition = scrollerAreaPreview?.current?.scrollTop - 100;
          setCurrentScrollPos(nextPosition);
          scrollerAreaPreview?.current?.scrollTo(0, nextPosition); 
        }          
        } style={{opacity: `${currentScrollPos === 0 ? 0.3 : 1}`, padding: "0px 8px 0px 16px", cursor: currentScrollPos === 0 ? "default" : "pointer"}}>
          <FontAwesomeIcon icon={["far", "arrow-up"]} style={{color: "#0090d1"}} />
        </span>
        <span onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          if (scrollTotalHeight - scrollerAreaPreview?.current?.offsetHeight <= currentScrollPos) return;   
          const nextPosition = scrollerAreaPreview?.current?.scrollTop + 100;
          setCurrentScrollPos(nextPosition);
          
          scrollerAreaPreview?.current?.scrollTo(0, nextPosition);          
        }
        }  style={{opacity: `${scrollTotalHeight - scrollerAreaPreview?.current?.offsetHeight <= currentScrollPos ? 0.3 : 1}`, padding: "0px 16px 0px 8px", cursor: scrollTotalHeight - scrollerAreaPreview?.current?.offsetHeight <= currentScrollPos ? "default" : "pointer"}}>
          <FontAwesomeIcon icon={["far", "arrow-down"]} style={{color: "#0090d1"}} />
        </span>
      </div>
      <div id="actions">
        <div onClick={e => isFullscreen ? handleExitFullscreen() : setIsFullscreen(true)}>
          <FontAwesomeIcon icon={["far", isFullscreen ? "compress" : "external-link-square-alt"]} style={{color: "#0090d1"}} />
        </div>
        { /* TODO ripristinare quando sarà chiara la funzione di cancellazione
        <div>
          <FontAwesomeIcon icon={["far", "trash-alt"]} style={{color: "#0090d1"}} />
        </div>
      */}
      </div>

    </div>
  );
};

export default Controls;